import React, { useState } from 'react';
import { HEMO_RANGES, getStatus, evaluateDiagnosis } from '../utils/calculators';

export default function Hemogram() {
    const [species, setSpecies] = useState('cat');
    const [values, setValues] = useState({});
    const [diagnoses, setDiagnoses] = useState({ wbc: [], rbc: [] });

    const handleChange = (key, val) => {
        setValues({ ...values, [key]: val });
    };

    const handleInterpret = () => {
        const statuses = {};
        Object.keys(HEMO_RANGES[species]).forEach(key => {
            statuses[key] = getStatus(species, key, parseFloat(values[key] || 0));
        });
        setDiagnoses(evaluateDiagnosis(species, statuses));
    };

    return (
        <div style={containerStyle}>
            <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom:'10px' }}>
                {species === 'cat' ? '🐱 Kedi' : '🐶 Köpek'} Hemogram Analizi
            </h2>
            <p style={{textAlign:'center', color:'#7f8c8d', fontSize:'12px', marginBottom:'20px'}}>Tam Kan Sayımı (CBC) ve Klinik Yorumlama</p>
            
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', width: '100%' }}>
                <button 
                    onClick={() => {setSpecies('cat'); setDiagnoses({ wbc: [], rbc: [] });}} 
                    style={species === 'cat' ? activeBtnLeft : inactiveBtnLeft}
                >Kedi</button>
                <button 
                    onClick={() => {setSpecies('dog'); setDiagnoses({ wbc: [], rbc: [] });}} 
                    style={species === 'dog' ? activeBtnRight : inactiveBtnRight}
                >Köpek</button>
            </div>

            <div style={gridContainer}>
                {Object.keys(HEMO_RANGES[species]).map(key => {
                    const status = getStatus(species, key, parseFloat(values[key] || 0));
                    const range = HEMO_RANGES[species][key];
                    return (
                        <div key={key} style={inputCard}>
                            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'5px'}}>
                                <label style={{ fontWeight: 'bold', fontSize: '13px', color:'#34495e', textTransform:'uppercase' }}>{key}</label>
                                <span style={{fontSize:'10px', color:'#95a5a6', fontWeight:'bold'}}>{range[0]}-{range[1]}</span>
                            </div>
                            <input 
                                type="number" 
                                step="0.1"
                                onChange={(e) => handleChange(key, e.target.value)} 
                                style={{ ...inputStyle, borderBottom: `2px solid ${status === 'Normal' ? '#2ecc71' : values[key] ? '#e74c3c' : '#eee'}` }} 
                                placeholder="Değer"
                            />
                            {values[key] && (
                                <div style={{ fontSize: '10px', textAlign:'right', marginTop:'2px', fontWeight: 'bold', color: status === 'Normal' ? '#27ae60' : status === 'Düşük' ? '#c0392b' : '#d35400' }}>
                                    {status}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <button onClick={handleInterpret} style={interpretBtn}>YORUMLA (TANI ANALİZİ)</button>

            {(diagnoses.wbc.length > 0 || diagnoses.rbc.length > 0) && (
                <div style={resultBox}>
                    <h3 style={{ color: '#2c3e50', marginTop: 0, borderBottom:'1px solid #eee', paddingBottom:'10px' }}>📋 Klinik Değerlendirme</h3>
                    {diagnoses.wbc.length > 0 && (
                        <div style={{ marginBottom: '15px' }}>
                            <h4 style={{ color: '#c0392b', marginBottom: '8px', fontSize:'15px' }}>🛡️ Lökogram (WBC) Bulguları:</h4>
                            {diagnoses.wbc.map((msg, i) => <div key={i} style={msgItem}>• {msg}</div>)}
                        </div>
                    )}
                    {diagnoses.rbc.length > 0 && (
                        <div>
                            <h4 style={{ color: '#2980b9', marginBottom: '8px', fontSize:'15px' }}>🩸 Eritrogram (RBC) Bulguları:</h4>
                            {diagnoses.rbc.map((msg, i) => <div key={i} style={msgItem}>• {msg}</div>)}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    padding: '15px', 
    maxWidth: '800px', 
    margin: '0 auto', 
    background: '#f4f7f6', 
    minHeight: '100vh', 
    fontFamily: "sans-serif",
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', 
    paddingBottom: 'env(safe-area-inset-bottom)'       
};

const btnBase = { 
    padding: '12px 30px', 
    border: 'none', 
    cursor: 'pointer', 
    fontWeight:'bold', 
    flex:1, 
    WebkitTapHighlightColor: 'transparent' 
};

const activeBtnLeft = { ...btnBase, background: '#2c3e50', color: 'white', borderRadius: '8px 0 0 8px' };
const inactiveBtnLeft = { ...btnBase, background: '#dfe6e9', color: '#7f8c8d', borderRadius: '8px 0 0 8px' };
const activeBtnRight = { ...btnBase, background: '#2c3e50', color: 'white', borderRadius: '0 8px 8px 0' };
const inactiveBtnRight = { ...btnBase, background: '#dfe6e9', color: '#7f8c8d', borderRadius: '0 8px 8px 0' };

const gridContainer = { 
    display: 'grid', 
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', 
    gap: '15px', 
    background: 'white', 
    padding: '15px', 
    borderRadius: '15px',
    boxSizing: 'border-box'
};

const inputCard = { display: 'flex', flexDirection: 'column', padding:'10px', background:'#f8f9fa', borderRadius:'8px', boxSizing: 'border-box' };

const inputStyle = { 
    padding: '8px', 
    flex: 1, 
    border: '1px solid #ddd', 
    borderRadius: '4px', 
    outline:'none', 
    fontSize: '16px', 
    WebkitAppearance: 'none', 
    width: '100%', 
    boxSizing: 'border-box' 
};

const interpretBtn = { width: '100%', padding: '16px', background: '#2980b9', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', fontSize:'16px', marginTop: '15px', WebkitTapHighlightColor: 'transparent', boxSizing: 'border-box' };
const resultBox = { marginTop: '25px', padding: '20px', background: '#fff', borderRadius: '15px', borderLeft: '8px solid #3498db', boxSizing: 'border-box' };
const msgItem = { margin: '8px 0', fontSize: '14px', background:'#f1f2f6', padding:'8px', borderRadius:'6px', wordBreak: 'break-word' };